export const checkMilestone = (streakCount, milestonesAwarded = []) => {
  for (const key of ['30', '60', '100']) {
    if (streakCount >= parseInt(key) && !milestonesAwarded.includes(key)) return key;
  }
  return null;
};

export const getExtensionDays = (m) => ({ '30': 30, '60': 60, '100': 180 }[m] ?? 0);

export const getMilestoneMessage = (m) => ({
  '30':  { title: '30 Days of Showing Up', body: "A full month of inner work. That's real commitment. We're adding a month to your journey as our way of saying thank you." },
  '60':  { title: '60 Days of Transformation', body: 'Two months of showing up for yourself. Remarkable. Two more months added to your path.' },
  '100': { title: '100 Days — Liberation Seeker', body: "One hundred days. You've walked the board. Six months more, because you've proven this practice matters to you." },
}[m] ?? { title: 'Milestone', body: 'Keep going.' });

export const updateStreakFirestore = async (uid, db, docFn, setDocFn, getDocFn) => {
  const today = new Date().toDateString();
  const ref = docFn(db, 'users', uid, 'progress', 'data');
  const snap = await getDocFn(ref);
  const data = snap.exists() ? snap.data() : {};
  const last = data.lastPracticeDate ? new Date(data.lastPracticeDate).toDateString() : null;
  if (last === today) {
    return { streakCount: data.streakCount ?? 0, milestonesAwarded: data.milestonesAwarded ?? [] };
  }
  const yesterday = new Date();
  yesterday.setDate(yesterday.getDate() - 1);
  const newStreak = last === yesterday.toDateString() ? (data.streakCount ?? 0) + 1 : 1;
  await setDocFn(ref, { streakCount: newStreak, lastPracticeDate: new Date().toISOString() }, { merge: true });
  return { streakCount: newStreak, milestonesAwarded: data.milestonesAwarded ?? [] };
};
